/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import SearchPage from '../pages/search/SearchPage'

export default function Search() {
  return <SearchPage />
}
